<template>
  <div class="pull-height animated" :class="{'zoomOutUp': isLock}">
    <div class="index">
      <!-- 左侧导航栏 -->
      <sidebar class="left"></sidebar>
      <div class="right">
        <div class="nav">
          <!-- 顶部导航栏 -->
          <top class="top"></top>
          <!-- 顶部标签卡 -->
          <tags></tags>
        </div>
        <!-- 主体视图层 -->
        <el-scrollbar style="height:100%">
          <el-card :body-style="siteContentViewHeight">
            <keep-alive>
              <router-view v-if="$route.meta.keepAlive"></router-view>
            </keep-alive>
            <router-view v-if="!$route.meta.keepAlive"></router-view>
          </el-card>
        </el-scrollbar>
        <div class="floating-module" v-if="faqFlag">
          <button class="floating-button" id="online-service" @click="openFAQ">
            <img src="static/img/kf.png" alt="在线客服">
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'
  import tags from './tags'
  import top from './top/'
  import sidebar from './sidebar/'
  import {resolveUrlPath} from "@/util/util"

  export default {
    components: {
      top,
      tags,
      sidebar
    },
    name: 'index',
    data() {
      return {
        faqFlag:false,
        menuInfo:{}
      }
    },
    created() {

    },
    mounted() {
      setTimeout(() => {
        this.getFAQ()
      }, 1000);

    },
    computed: {
      ...mapGetters(['isLock','menu']),
      siteContentViewHeight() {
        var height = document.documentElement.clientHeight - 150
        return {height: height + 'px'}
      },
    },
    props: [],
    methods: {
      getFAQ(){
        for(let i in this.menu){
          if(this.menu[i].name == '云智助手'){
            this.menu[i].children.forEach(item=>{
              if(item.name == '云智小E'){
                this.faqFlag = true
                this.menuInfo=Object.assign({},item)
              }
            })
          }
        }
      },
      openFAQ(){
        this.$router.push({
          path: resolveUrlPath(this.menuInfo.path, this.menuInfo.label),
          query: ''
        });
      }
    }
  }
</script>

<style lang="scss" scoped>
  .index {
    display: flex;
    position: relative;
    height: 100%;
    background: #fff;
    overflow: hidden;
    .left {
      padding-top: 40px;
      width: 200px;
    }
    .right {
      padding-top: 82px;
      position: relative;
      height: 100%;
      box-sizing: border-box;
      overflow: hidden;
      flex: 1;
      background: #f1f4f5;
    }
    .main {
      height: 100%;
      background: #f1f4f5;
      padding: 15px;
      box-sizing: border-box;
      overflow-y: scroll;
      .router {
        padding: 15px 8px;
        background: #fff;
        min-height: 100%;
        height: auto;
        overflow: hidden;
        border-radius: 5px;
        box-sizing: border-box;
      }
    }
    .nav {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      z-index: 999;
    }
    .top {
      /*margin-bottom: 2px;*/
    }
    .floating-module {
      position: fixed;
      right: 10px;
      top: 90%;
      transform: translateY(-50%);
      display: flex;
      flex-direction: column;
      align-items: center;
      z-index: 999;
    }
    .floating-button {
      width: 60px;
      height: 60px;
      background-color: #ffffff;
      color: white;
      border: none;
      border-radius: 50%;
      margin: 5px 0;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      box-shadow: 0 5px 10px rgba(0, 0, 0, 0.3);
      transition: background-color 0.3s, transform 0.3s;
    }
    .floating-button:hover {
      background-color: #4095e5;
      transform: scale(1.1);
    }
    .floating-button img {
      width: 80%;
      height: 60%;
    }
  }
</style>



// WEBPACK FOOTER //
// index.vue?ca4b3d1c